import styled from "styled-components";
export const ChatRightStyle = styled.div`
  margin-bottom: 5px;
  width: 50%;
  margin-left: auto;
  .user {
    padding: 5px 0px;
    img {
      background-color: #f0f0f0;
      width: 30px;
      height: 30px;
      border: none;
    }
  }
  .text {
    width: fit-content;
    padding: 10px 20px;
    word-wrap: break-word;
    background-color: ${({ theme }) => theme.chatRight};
    border-radius: 10px;
    p {
      position: relative;
    }
  }
  .link {
    color: ${({ theme }) => theme.text} !important;
    font-size: 12px;
    cursor: pointer;
  }
`;
